import * as React from "react";

const OrderList: React.FC = () => {
    return (
        <svg width={40} height={41} viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_16763_81867)">
                <path
                    d="M11.667 25.485h11.666v3.334H11.667v-3.334zm0-6.666h16.666v3.333H11.667v-3.334zm0-6.667h16.666v3.333H11.667v-3.333zm20-6.667H24.7C24 3.552 22.167 2.152 20 2.152c-2.167 0-4 1.4-4.7 3.333H8.333c-.233 0-.45.017-.666.067a3.346 3.346 0 00-1.684.916c-.3.3-.55.667-.716 1.067A3.21 3.21 0 005 8.818v23.334c0 .45.1.9.267 1.3.166.4.416.75.716 1.067.45.45 1.034.783 1.684.916.216.033.433.05.666.05h23.334c1.833 0 3.333-1.5 3.333-3.333V8.818c0-1.833-1.5-3.333-3.333-3.333zM20 5.068c.683 0 1.25.567 1.25 1.25A1.26 1.26 0 0120 7.568a1.26 1.26 0 01-1.25-1.25c0-.683.567-1.25 1.25-1.25zm11.667 27.084H8.333V8.818h23.334v23.334z"
                    fill="#0C0C0C"
                />
            </g>
            <defs>
                <clipPath id="clip0_16763_81867">
                    <path fill="#fff" transform="translate(0 .485)" d="M0 0H40V40H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(OrderList);
